import React from 'react';
import { motion } from 'framer-motion';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useData } from '../../contexts/DataContext';
import { formatZAR } from '../../utils/currency';
export function SalesChart() {
  const {
    orders
  } = useData();
  // Generate last 7 days data
  const data = Array.from({
    length: 7
  }).map((_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (6 - i));
    const dateStr = d.toISOString().split('T')[0];
    const dayOrders = orders.filter(o => o.date.startsWith(dateStr));
    const sales = dayOrders.reduce((sum, o) => sum + o.total, 0);
    return {
      name: d.toLocaleDateString('en-US', {
        weekday: 'short'
      }),
      sales: sales
    };
  });
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.2
  }} className="bg-white rounded-2xl border border-rose-100 shadow-sm p-6 h-[400px]" data-id="element-428">
      <div className="flex justify-between items-center mb-6" data-id="element-429">
        <div data-id="element-430">
          <h3 className="text-lg font-bold text-gray-900 font-serif" data-id="element-431">
            Sales Overview
          </h3>
          <p className="text-sm text-gray-500" data-id="element-432">Last 7 days performance</p>
        </div>
        <select className="bg-gray-50 border border-gray-200 text-gray-700 text-sm rounded-lg focus:ring-rose-500 focus:border-rose-500 block p-2.5" data-id="element-433">
          <option data-id="element-434">Last 7 Days</option>
          <option data-id="element-435">Last 30 Days</option>
          <option data-id="element-436">This Year</option>
        </select>
      </div>

      <div className="h-[300px] w-full" data-id="element-437">
        <ResponsiveContainer width="100%" height="100%" data-id="element-438">
          <AreaChart data={data} margin={{
          top: 10,
          right: 10,
          left: 0,
          bottom: 0
        }} data-id="element-439">
            <defs data-id="element-440">
              <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1" data-id="element-441">
                <stop offset="5%" stopColor="#f43f5e" stopOpacity={0.1} data-id="element-442" />
                <stop offset="95%" stopColor="#f43f5e" stopOpacity={0} data-id="element-443" />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" data-id="element-444" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
            fill: '#9ca3af',
            fontSize: 12
          }} dy={10} data-id="element-445" />
            <YAxis axisLine={false} tickLine={false} tick={{
            fill: '#9ca3af',
            fontSize: 12
          }} tickFormatter={value => `R${value}`} data-id="element-446" />
            <Tooltip contentStyle={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
          }} formatter={(value: number) => [formatZAR(value), 'Sales']} data-id="element-447" />
            <Area type="monotone" dataKey="sales" stroke="#f43f5e" strokeWidth={3} fillOpacity={1} fill="url(#colorSales)" data-id="element-448" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </motion.div>;
}